import React from "react";

const TableRow = (props) => {
  return (
    <tr
      {...props}
      className={`border-b-2 last:border-b-0 hover:bg-slate-100 ${props.className}`}
    >
      {props.children}
    </tr>
  );
};

export default TableRow;
